webpackJsonp([10],{

/***/ "F5nP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_service__ = __webpack_require__("fkT8");


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var Modal = function () {
    _createClass(Modal, [{
        key: 'modalContentPlaceholder',
        get: function get() {
            return '...';
        }
    }, {
        key: 'template',
        get: function get() {
            return '\n<div id="' + this.modalId + '"\n     class="modal fade"\n     data-backdrop="static"\n     tabindex="-1"\n     role="dialog"\n     aria-labelledby="exampleModalLabel"\n     aria-hidden="true"\n     >\n  <div class="modal-dialog" role="document">\n    <div class="modal-content">\n      <div class="modal-header">\n        <h5 class="modal-title" id="' + this.modalId + '-label"></h5>\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n          <span aria-hidden="true">&times;</span>\n        </button>\n      </div>\n      <div id="' + this.modalId + '-content" class="modal-body">\n        ' + this.modalContentPlaceholder + '\n      </div>\n    </div>\n  </div>\n</div>\n';
        }
    }]);

    function Modal() {
        _classCallCheck(this, Modal);

        this.isPreviousRequestResolved = true;
    }

    _createClass(Modal, [{
        key: 'setTriggerSelector',
        value: function setTriggerSelector(modalTriggerSelector) {
            this.modalTriggerSelector = modalTriggerSelector;
            return this;
        }
    }, {
        key: 'setModalId',
        value: function setModalId(modalId) {
            this.modalId = modalId;
            return this;
        }
    }, {
        key: 'setModalWrapperId',
        value: function setModalWrapperId(modalWrapperId) {
            this.modalWrapperId = modalWrapperId;
            return this;
        }
    }, {
        key: 'setUpListenersForm',
        value: function setUpListenersForm() {
            var _this = this;

            $(document).on('click', this.modalTriggerSelector, function (event) {
                _this.handleOpenModalForm(event);
            });
            return this;
        }
    }, {
        key: 'setUpListenersContent',
        value: function setUpListenersContent() {
            var _this2 = this;

            $(document).on('click', this.modalTriggerSelector, function (event) {
                _this2.handleOpenModalContent(event);
            });
            return this;
        }

        /**
         * Gets data from element that triggered modal (url, title)
         * Eg. <button data-url="example.com"
         *             data-title="Example title>
         *       Open modal
         *     </button>
         * @param htmlElement
         */

    }, {
        key: 'handleTriggerElementData',
        value: function handleTriggerElementData(htmlElement) {
            if (!$(htmlElement).hasClass(this.modalTriggerSelector)) {
                htmlElement = $(htmlElement).closest(this.modalTriggerSelector);
            }
            var element = $(htmlElement);
            $('#' + this.modalId + '-label').html(element.data('title'));
            this.url = element.data('url');
        }
    }, {
        key: 'handleOpenModalForm',
        value: function handleOpenModalForm(event) {
            var _this3 = this;

            this.handleTriggerElementData(event.target);
            __WEBPACK_IMPORTED_MODULE_0__form_service__["a" /* default */].getForm(this.url).done(function (form) {
                return _this3.renderForm(form);
            });
        }
    }, {
        key: 'handleOpenModalContent',
        value: function handleOpenModalContent(event) {
            this.handleTriggerElementData(event.target);
            var self = this;
            $.ajax({
                url: this.url,
                type: 'get'
            }).done(function (response) {
                self.renderContent(response);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            $('#' + this.modalWrapperId).html(this.template);
            $('#' + this.modalId).on('hidden.bs.modal', function () {
                _this4.cleanModalContent();
                $('#' + _this4.modalId).removeClass('show');
            });
            $('#' + this.modalId).on('modal.afterPostDone', function () {
                _this4.cleanModalContent();
            });
            $('button.close').on('click', function () {
                _this4.cleanModalContent();
            });
        }
    }, {
        key: 'cleanModalContent',
        value: function cleanModalContent() {
            $('#' + this.modalId + '-content').html(this.modalContentPlaceholder);
            this.isPreviousRequestResolved = true;
        }
    }, {
        key: 'renderContent',
        value: function renderContent(content) {
            this.isPreviousRequestResolved = true;
            $('#' + this.modalId + '-content').html(content);

            $('#' + this.modalId).trigger('modal.afterRenderContent');
        }
    }, {
        key: 'renderForm',
        value: function renderForm(content) {
            this.isPreviousRequestResolved = true;
            $('#' + this.modalId + '-content').html(content);

            $('#' + this.modalId).trigger('modal.afterRenderForm');
            this.addSubmitListener();
        }
    }, {
        key: 'addSubmitListener',
        value: function addSubmitListener() {
            var _this5 = this;

            var form = $('#' + this.modalId + '-content form');
            if (form.length) {
                form.on('submit', function (event) {
                    event.preventDefault();
                    if (_this5.isPreviousRequestResolved) {
                        _this5.isPreviousRequestResolved = false;
                        _this5.handleFormSubmit(event);
                    }
                });
            }
        }
    }, {
        key: 'handleFormSubmit',
        value: function handleFormSubmit(event) {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_0__form_service__["a" /* default */].postForm(this.url, event.target).done(function (responseText, jqXHR, response) {
                if (response.status === 206) {
                    _this6.renderContent(responseText);
                } else {
                    $('#' + _this6.modalId).trigger('modal.afterPostDone', [response.status, responseText]);
                }
            }).fail(function (error) {
                _this6.renderForm(error.responseText);
            });
        }
    }]);

    return Modal;
}();

/* harmony default export */ __webpack_exports__["a"] = (Modal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Mhfh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service_report_form__ = __webpack_require__("TbdY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_modal__ = __webpack_require__("F5nP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_datepicker_dist_locales_bootstrap_datepicker_pl_min__ = __webpack_require__("oxqt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_datepicker_dist_locales_bootstrap_datepicker_pl_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_datepicker_dist_locales_bootstrap_datepicker_pl_min__);






new __WEBPACK_IMPORTED_MODULE_0__utils_service_report_form__["a" /* default */]();

$(document).ready(function () {
    $(".datepicker").datepicker("destroy");
    $(".datepicker").datepicker({
        startDate: new Date('01-01-1996'),
        endDate: new Date(),
        language: 'pl'
    });
});

var serviceReportRules = new __WEBPACK_IMPORTED_MODULE_1__utils_modal__["a" /* default */]().setTriggerSelector('.service-report-rules-modal-trigger').setModalId('service-report-rules-modal').setModalWrapperId('service-report-rules-modal-wrapper').setUpListenersForm();
serviceReportRules.render();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "TbdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gus_service__ = __webpack_require__("ZwpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__("yEhc");


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ServiceReportForm = function () {
    function ServiceReportForm() {
        _classCallCheck(this, ServiceReportForm);

        this.form = '#service-report-create-form';
        this.nip = '#service_report_form_nip';
        this.companyName = '#service_report_form_companyName';
        this.companyCity = '#service_report_form_companyAddress_city';
        this.companyStreet = '#service_report_form_companyAddress_street';
        this.companyNumberBuilding = '#service_report_form_companyAddress_buildingNumber';
        this.companyNumberLocal = '#service_report_form_companyAddress_apartmentNumber';
        this.companyPostCode = '#service_report_form_companyAddress_postCode';
        this.companyPostCity = '#service_report_form_companyAddress_post';
        this.diffDeviceAddress = '#service_report_form_diffInstallationAddress';
        this.deviceCity = '#service_report_form_deviceAddress_city';
        this.deviceStreet = '#service_report_form_deviceAddress_street';
        this.deviceNumberBuilding = '#service_report_form_deviceAddress_buildingNumber';
        this.deviceNumberLocal = '#service_report_form_deviceAddress_apartmentNumber';
        this.devicePostCode = '#service_report_form_deviceAddress_postCode';
        this.devicePostCity = '#service_report_form_deviceAddress_post';
        this.deviceProvince = '#service_report_form_deviceProvince';
        this.submitButton = '#service_report_form_submit';
        this.modalAcceptRulesButton = '#modal-accept-rules-button';

        this.onLoad();
        this.setUpListeners();
    }

    _createClass(ServiceReportForm, [{
        key: "onLoad",
        value: function onLoad() {
            if (this.nipIsEmpty()) {
                this.disableDifferentDeviceAddressCheckbox();
            } else if (this.isInstallationAddressTheSame()) {
                this.disableOrEnableDeviceAddress();
            }
        }
    }, {
        key: "setUpListeners",
        value: function setUpListeners() {
            var _this = this;

            $(document).on('change', this.diffDeviceAddress, function () {
                _this.disableOrEnableDeviceAddress();
            });
            $(document).on('change', this.nip, function () {
                var nipValue = $(_this.nip).val();
                if (__WEBPACK_IMPORTED_MODULE_1__validators__["a" /* default */].nip(nipValue)) {
                    _this.getDataFromGusAjax();
                } else {
                    _this.disableDifferentDeviceAddressCheckbox();
                }
            });

            $("#service_report_form_files_file").change(function () {
                _this.showImages();
            });

            $(document).on('click', this.submitButton, function () {
                event.preventDefault();
            });

            $(document).on('click', this.modalAcceptRulesButton, function () {
                $(_this.form).submit();
                $('#modal').modal('toggle');
            });
        }
    }, {
        key: "getDataFromGusAjax",
        value: function getDataFromGusAjax() {
            var self = this;
            var url = $(this.nip).data('gusurl');
            __WEBPACK_IMPORTED_MODULE_0__gus_service__["a" /* default */].getDataByNip(url, $(self.nip).val()).done(function (data) {
                self.setDataFromGusApi(data);
                $(self.diffDeviceAddress).prop('disabled', false);
            }).fail(function () {
                self.disableDifferentDeviceAddressCheckbox();
            });
        }
    }, {
        key: "disableOrEnableDeviceAddress",
        value: function disableOrEnableDeviceAddress() {
            var disabledValue = this.isInstallationAddressTheSame();
            $(this.deviceCity).prop('disabled', disabledValue);
            $(this.deviceStreet).prop('disabled', disabledValue);
            $(this.deviceNumberBuilding).prop('disabled', disabledValue);
            $(this.deviceNumberLocal).prop('disabled', disabledValue);
            $(this.devicePostCode).prop('disabled', disabledValue);
            $(this.devicePostCity).prop('disabled', disabledValue);
            $(this.deviceProvince).prop('disabled', disabledValue);
        }
    }, {
        key: "isInstallationAddressTheSame",
        value: function isInstallationAddressTheSame() {
            return !$(this.diffDeviceAddress).is(':checked');
        }
    }, {
        key: "setDataFromGusApi",
        value: function setDataFromGusApi(data) {
            $(this.companyName).val(data.companyName).prop('readonly', true);
            $(this.companyCity).val(data.companyCity).prop('readonly', true);
            $(this.companyStreet).val(data.companyStreet).prop('readonly', true);
            $(this.companyNumberBuilding).val(data.companyNumberBuilding).prop('readonly', true);
            $(this.companyNumberLocal).val(data.companyNumberLocal).prop('readonly', true);
            $(this.companyPostCode).val(data.companyPostCode).prop('readonly', true);
            $(this.companyPostCity).val(data.companyPostCity).prop('readonly', true);
        }
    }, {
        key: "disableDifferentDeviceAddressCheckbox",
        value: function disableDifferentDeviceAddressCheckbox() {
            $(this.diffDeviceAddress).prop('disabled', true).prop('checked', false);
            this.disableOrEnableDeviceAddress();
        }
    }, {
        key: "nipIsEmpty",
        value: function nipIsEmpty() {
            return $('#service_report_form_nip').val() === '';
        }
    }, {
        key: "removeImagesWrapper",
        value: function removeImagesWrapper() {
            $("#images-wrapper img").remove();
            $("#images-wrapper").empty();
        }
    }, {
        key: "getFilesQuantity",
        value: function getFilesQuantity() {
            return document.getElementById("service_report_form_files_file").files.length;
        }
    }, {
        key: "createAndAppendImage",
        value: function createAndAppendImage(url) {
            $('#images-wrapper').append("<div class='col-md-4 col-12 one_img'><div class='wrap'><img src='" + url + "' alt='img_glob'></div></div>");
        }
    }, {
        key: "showImages",
        value: function showImages() {
            this.removeImagesWrapper();
            var validImageTypes = ["image/gif", "image/jpeg", "image/jpg", "image/png"];

            var filesQuantity = this.getFilesQuantity();

            for (var i = 0; i < filesQuantity; i++) {
                var type = event.target.files[i]["type"];
                if ($.inArray(type, validImageTypes) !== -1) {
                    this.createAndAppendImage(URL.createObjectURL(event.target.files[i]));
                }
            }
        }
    }]);

    return ServiceReportForm;
}();

/* harmony default export */ __webpack_exports__["a"] = (ServiceReportForm);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "ZwpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GusService = function () {
    function GusService() {
        _classCallCheck(this, GusService);
    }

    _createClass(GusService, null, [{
        key: "getDataByNip",
        value: function getDataByNip(url, nip) {
            return $.ajax({
                url: url,
                method: "post",
                data: { nip: nip },
                dataType: "json"
            });
        }
    }]);

    return GusService;
}();

/* harmony default export */ __webpack_exports__["a"] = (GusService);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "fkT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormService = function () {
    function FormService() {
        _classCallCheck(this, FormService);
    }

    _createClass(FormService, null, [{
        key: 'getForm',
        value: function getForm(url) {
            return $.get({ url: url });
        }
    }, {
        key: 'postForm',
        value: function postForm(url, data) {
            return $.get({
                method: 'POST',
                url: url,
                data: new FormData(data),
                processData: false,
                contentType: false
            });
        }
    }]);

    return FormService;
}();

/* harmony default export */ __webpack_exports__["a"] = (FormService);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "oxqt":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {!function(a){a.fn.datepicker.dates.pl={days:["Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota"],daysShort:["Niedz.","Pon.","Wt.","Śr.","Czw.","Piąt.","Sob."],daysMin:["Ndz.","Pn.","Wt.","Śr.","Czw.","Pt.","Sob."],months:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],monthsShort:["Sty.","Lut.","Mar.","Kwi.","Maj","Cze.","Lip.","Sie.","Wrz.","Paź.","Lis.","Gru."],today:"Dzisiaj",weekStart:1,clear:"Wyczyść",format:"dd.mm.yyyy"}}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "yEhc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validators = function () {
    function Validators() {
        _classCallCheck(this, Validators);
    }

    _createClass(Validators, null, [{
        key: "nip",
        value: function nip(_nip) {
            var nipWithoutDashes = _nip.replace(/-/g, "");
            var reg = /^[0-9]{10}$/;
            if (reg.test(nipWithoutDashes) == false) {
                return false;
            } else {
                var digits = ("" + nipWithoutDashes).split("");
                var checksum = (6 * parseInt(digits[0]) + 5 * parseInt(digits[1]) + 7 * parseInt(digits[2]) + 2 * parseInt(digits[3]) + 3 * parseInt(digits[4]) + 4 * parseInt(digits[5]) + 5 * parseInt(digits[6]) + 6 * parseInt(digits[7]) + 7 * parseInt(digits[8])) % 11;

                return parseInt(digits[9]) == checksum;
            }
        }
    }]);

    return Validators;
}();

/* harmony default export */ __webpack_exports__["a"] = (Validators);

/***/ })

},["Mhfh"]);


// WEBPACK FOOTER //
// js/service-report-create.739ce452.js